// EDD start
    // Fetch estimated delivery date from EDD API
    async function fetchAccessToken(customerPincode, skuCode) {
        const url = 'https://5gg66a38lj.execute-api.ap-south-1.amazonaws.com/prod/edd';
        const params = new URLSearchParams({ 
            customerPincode: customerPincode, // Use the parameter name as the key
            skuCode: skuCode                 // Add skuCode here
        });
  
        try {
        const response = await fetch(`${url}?${params.toString()}`, {
            method: 'GET',
            mode: 'cors'
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        }
  
        const data = await response.json();
        console.log('EDD skuCode:', skuCode);
        console.log('EDD Response:', data);
  
        if (data.edd && data.sla_days && data.drop_pincode) {
            console.log(`Pincode: ${data.drop_pincode}`);
            console.log(`Estimated Delivery Date: ${data.edd}`);
            console.log(`SLA Days: ${data.sla_days}`);
  
            const addressDetails = await fetchPincodeDetails(customerPincode); // ✅ fixed line
            const addressDetails_pin = addressDetails.pin;
            const addressDetails_state = addressDetails.state;
            // const addressDetails_district = addressDetails.district;
            const addressDetails_district = addressDetails.district ? ' ('+addressDetails.district+')' : '';
            console.log('Address Details:', addressDetails);
  
            const pincode_label = document.getElementById('edd-get-pincode-pdp-label');
            const pincode_input = document.getElementById('edd-get-pincode-pdp');
            const pincode_temp_store = document.getElementById('edd-get-pincode-pdp-tempStore');
            const edd_submit_btn = document.getElementById('edd-get-pincode-pdp-submitBtn');
            
            // const pincode_checkbox = document.getElementById('edd-get-pincode-checkbox');
  
            let message = 'Estimated Delivery: ' + data.sla_days + ' days';
  
            pincode_label.innerText = message;
            pincode_temp_store.value = addressDetails_pin;
            pincode_input.value = '';
            pincode_input.placeholder = addressDetails_pin+addressDetails_district;
            edd_submit_btn.textContent = 'Change';
            // pincode_checkbox.checked = true;
        }
  
        } catch (error) {
          const pincode_label = document.getElementById('edd-get-pincode-pdp-label');
          const pincode_input = document.getElementById('edd-get-pincode-pdp');
          
          pincode_label.innerText = 'Estimated Delivery Unavailable';
          pincode_input.value = '';
          console.error('Failed to fetch EDD info:', error.message);
        }
    }
  
    // Fetch address details using India Post API
    const PIN_STATE_MAP = [
        { start: 110000, end: 119999, capital: 'Delhi' },
        { start: 120000, end: 129999, capital: 'Chandigarh' },
        { start: 130000, end: 169999, capital: 'Chandigarh' },
        { start: 170000, end: 199999, capital: 'Shimla' },
        { start: 200000, end: 269999, capital: 'Lucknow' },
        { start: 300000, end: 349999, capital: 'Jaipur' },
        { start: 350000, end: 399999, capital: 'Gandhinagar' },
        { start: 400000, end: 449999, capital: 'Mumbai' },
        { start: 450000, end: 489999, capital: 'Bhopal' },
        { start: 500000, end: 539999, capital: 'Hyderabad' },
        { start: 540000, end: 599999, capital: 'Bengaluru' },
        { start: 600000, end: 649999, capital: 'Chennai' },
        { start: 650000, end: 689999, capital: 'Thiruvananthapuram' },
        { start: 700000, end: 749999, capital: 'Kolkata' },
        { start: 750000, end: 799999, capital: 'Bhubaneswar' },
        { start: 800000, end: 849999, capital: 'Patna' },
        { start: 850000, end: 889999, capital: 'Ranchi' },
        { start: 900000, end: 999999, capital: 'Dispur' },
    ];
    
    async function fetchPincodeDetails(pincode) {
        const url = `https://api.postalpincode.in/pincode/${pincode}`;
    
        try {
        const response = await fetch(url);
    
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
    
        if (data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length > 0) {
            const postOffice = data[0].PostOffice[0];
            const state = postOffice.State;
            const pin = postOffice.Pincode;
            const district = postOffice.District
    
            console.log('✅ State:', state);
            console.log('✅ Pincode:', pin);
            console.log('✅ District:', district);
    
            return { state, pin, district };
        } else {
            console.warn('❌ No records found for this pincode.');
    
            // Check in PIN_STATE_MAP
            const pinNumber = Number(pincode);
            if (!isNaN(pinNumber)) {
            const entry = PIN_STATE_MAP.find(item => pinNumber >= item.start && pinNumber <= item.end);
            if (entry) {
                console.log(`🔎 Found capital in PIN_STATE_MAP: ${entry.capital}`);
                return { state: entry.capital, pin: pincode, district: null };
            }
            }
    
            return null;
        }
        } catch (error) {
        console.error('❌ Error fetching pincode details:', error);
        }
    }
  
    
    // Clear checkbox on input focus
    // document.getElementById('edd-get-pincode-pdp').addEventListener('click', function () {
    //     const pincode_checkbox = document.getElementById('edd-get-pincode-checkbox');
    //     pincode_checkbox.checked = false;
    //     console.log('Pincode input focused:', this);
    // });
  
    // Trigger EDD fetch on submit button click
    document.getElementById('edd-get-pincode-pdp-submitBtn').addEventListener('click', () => {
      const pincode_label = document.getElementById('edd-get-pincode-pdp-label');
      const pincode_input = document.getElementById('edd-get-pincode-pdp');
      const pincode_input_existID = document.getElementById('edd-get-pincode-pdp-tempStore');
      const eddButton = document.getElementById('edd-get-pincode-pdp-submitBtn');
  
      const productSkuElement = document.querySelector('.product_sku_code');
      const skuValue = productSkuElement?.value?.trim() || '';
  
      const buttonText = eddButton.textContent.trim();
  
      // Case: Button text is 'Check'
      if (buttonText === 'Check') {
          const pincode = pincode_input.value.trim();
  
          if (pincode === '') {
              alert('Please enter a pincode.');
              return;
          }
  
          // Validation: exactly 6 digits
          const validPincodeRegex = /^\d{6}$/;
          if (!validPincodeRegex.test(pincode)) {
              alert('Please enter a valid 6-digit pincode containing digits only.');
              return;
          }
  
          if (skuValue === '') {
              alert('Please enter a skuValue.');
              return;
          }
  
          pincode_label.innerText = 'Checking delivery date...';
          fetchAccessToken(pincode, skuValue);
      }
  
      // Case: Button text is 'Change'
      else if (buttonText === 'Change') {
          const pincode_input_exist = pincode_input_existID?.value?.trim() || '';
  
          if (pincode_input_exist === '') {
              alert('Please enter a pincode_input_exist.');
              return;
          }
  
          if (skuValue === '') {
              alert('Please enter a skuValue.');
              return;
          }

          pincode_input.placeholder = 'Enter pincode';
  
          const pincode = pincode_input_exist;
  
          pincode_label.innerText = 'Enter your pincode';
          eddButton.textContent = 'Check';
          // fetchAccessToken(pincode, skuValue);
      }
  });

